<ion-card>
  <ion-card-content [ngSwitch]="endDeliveryOrderView">
    <app-payment-reminder (onResult)="onPaymentReminderResult($event)" [order]="order"
      *ngSwitchCase="EndDeliveryOrderView.PaymentReminder" [@enterTrigger]></app-payment-reminder>
    <app-confirm-delivery (onResult)="onConfirmDeliveryResult($event)" [order]="order"
      *ngSwitchCase="EndDeliveryOrderView.ConfirmDelivery" [@enterTrigger]>
    </app-confirm-delivery>
  </ion-card-content>
</ion-card>